<template>
  <v-sheet
    v-ripple
    class="external-link"
    outlined
    rounded
  >
    <a
      class="d-flex align-center text-decoration-none grey--text text--darken-3 px-6 py-4"
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div>
        <slot />
      </div>
      <v-spacer />
      <v-icon small>
        fa-regular fa-arrow-up-right-from-square
      </v-icon>
    </a>
  </v-sheet>
</template>

<script>
export default {
  name: 'ExternalLink',
  props: {
    href: {
      type: String,
      default: ''
    }
  }
}
</script>
